import * as _ from "lodash";
import * as moment from "moment-timezone";
import * as React from "react";
import styled, { css } from "styled-components";

import { Label } from "src/library/components/Forms";
import { CheckboxStyled } from "src/library/components/Forms/Checkbox";
import Grid from "src/library/components/Hedron";
import { IDeliveryDays } from "src/core/drops/api/drops.api";

type Day = 1 | 2 | 3 | 4 | 5 | 6 | 7;
type IScheduleDays = Day[];

interface IScheduleDayPickerProps {
  value: IScheduleDays;
  availableDays?: IDeliveryDays;
  handleChange: (days: IScheduleDays) => void;
}

const ScheduleDayPicker: React.ReactFCWithChildren<IScheduleDayPickerProps> = props => {
  const handleSetDay = (day: Day) => {
    if (_.includes(props.value, day)) {
      props.handleChange(_.sortBy(_.pull(props.value, day)));
    } else {
      if (props.value) {
        props.handleChange(_.sortBy(_.concat(props.value, day)));
      } else {
        props.handleChange(_.concat([ day ]));
      }
    }
  };

  const isChecked = (day: Day) => {
    return _.includes(props.value, day);
  };

  const isDisabled = (day: Day) => {
    if (!props.availableDays) {
      return false;
    }

    return !_.includes(_.values(props.availableDays), day);
  };

  return (
    <Wrapper direction="horizontal">
      {_.map([
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ], (day: Day) => (
        <DeliveryDayWrapper
          direction="vertical"
          key={day}
        >
          <Grid.Box>
            <CheckboxStyled
              name={`delivery-day-${day}`}
              id={`delivery-day-${day}`}
              checked={isChecked(day)}
              disabled={isDisabled(day)}
              onChange={() => handleSetDay(day)}
            />
          </Grid.Box>

          <LabelWrapper>
            <Label
              className={isDisabled(day) ? "disabled" : ""}
              for={`delivery-day-${day}`}
              label={moment
                .utc()
                .isoWeekday(day)
                .format("ddd")}
            />
          </LabelWrapper>
        </DeliveryDayWrapper>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled(Grid.Bounds)`
  width: 100%;
`;

const DeliveryDayWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.sm};
    align-items: center;
    justify-content: center;
  `}
`;

const LabelWrapper = styled(Grid.Box)`
  padding-top: ${({ theme }) => theme.spacing.padding.xs};
`;

export default ScheduleDayPicker;
